import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

const TableTags = ({ children, withGap = true, ...props }) => {
  return (
    <div
      {...props}
      className={cn(styles.root, {
        [styles.tagsGap]: withGap,
        [styles.interactive]: isInteractive(props),
      })}
    >
      {children}
    </div>
  );
};

export default TableTags;

function isInteractive(props = {}) {
  return Object.keys(props).some(
    (key) => key.startsWith('on') && typeof props[key] === 'function'
  );
}
